import {ValueObject} from '@s-ui/domain'

import {InvalidParamsSharedError} from '../../shared/Errors/InvalidParamsSharedError.js'

export class GetIsMakeHiredRequest extends ValueObject {
  #makeId

  static validate({makeId}) {
    if (!makeId) {
      throw InvalidParamsSharedError.create(`[GetIsMakeHiredRequest.validate] param makeId is required`)
    }
  }

  constructor({makeId}) {
    super()

    this.#makeId = makeId
  }

  static create({makeId}) {
    GetIsMakeHiredRequest.validate({makeId})
    return new GetIsMakeHiredRequest({
      makeId
    })
  }

  get makeId() {
    return this.#makeId
  }
}
